export const EN_US = 'en-US'; /* English - US */
export const KO_KR = 'ko-KR'; /* Korea - South Korea */
